import * as Yup from "yup";

const passwordRules = Yup.string()
  .required("Password is required")
  .min(12, "Password must be at least 12 characters")
  .matches(/[A-Z]/, "Password must contain an uppercase letter")
  .matches(/[a-z]/, "Password must contain a lowercase letter")
  .matches(/[0-9]/, "Password must contain a number")
  .matches(/[\W_]/, "Password must contain a special character");

export const addUserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|net|org|edu|gov|in|co|io|info|biz)$/,
      "Please enter a valid email address with a proper domain suffix (e.g., .com, .net, .org)."
    ),
  default_language: Yup.string().required('Default language is required'),
  timezone: Yup.string().required('Timezone is required'),
  password: passwordRules,
});

export const editUserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|net|org|edu|gov|in|co|io|info|biz)$/,
      "Please enter a valid email address with a proper domain suffix (e.g., .com, .net, .org)."
    ),
  default_language: Yup.string().required('Default language is required'),
  timezone: Yup.string().required('Timezone is required'),
  password: Yup.string().test(
    "is-password-valid",
    "Password must be at least 12 characters with uppercase, lowercase, number, and special character",
    function (value) {
      if (!value || value === "********") {
        return true;
      }
      return (
        value.length >= 12 &&
        /[A-Z]/.test(value) &&
        /[a-z]/.test(value) &&
        /[0-9]/.test(value) &&
        /[\W_]/.test(value)
      );
    }
  ),
});

export const updateUserProfileSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  region_code: Yup.string().required("Please select Region"),
  country_code: Yup.string().required("Please select country"),
  timezone: Yup.string().required("Please select timezone"),
});

export const changePasswordSchema = Yup.object().shape({
  password: passwordRules,
  newPassword: Yup.string()
    .required("New password is required")
    .notOneOf(
      [Yup.ref("password"), null],
      "New password cannot be the same as the old password"
    )
    .min(12, "New password must be at least 12 characters")
    .matches(/[A-Z]/, "New password must contain an uppercase letter")
    .matches(/[a-z]/, "New password must contain a lowercase letter")
    .matches(/[0-9]/, "New password must contain a number")
    .matches(/[\W_]/, "New password must contain a special character"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
});
